import React, { useEffect, useState } from "react";
import estilo from "./styles/Registro.module.css";
import supabase from "../supabase/supabaseClient";
import { Link, useNavigate } from "react-router-dom";

function Registro() {
  let navigate = useNavigate();

  const [alertaRegistro, setAlertaRegistro] = useState(null);
  const [formDatos, setFormDatos] = useState({
    correo: "",
    contraseña: "",
    confirmar_contraseña: "",
    nombre_usuario: "",
  });
  const [condicionesValidas, setCondicionesValidas] = useState(false);
  const [validaciones, setValidaciones] = useState({
    correo: false,
    contraseña: false,
    confirmar_contraseña: false,
    nombre_usuario: false,
  });

  //captura de inputs
  function capturarInputs(e) {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "correo") {
      if (value.includes("@")) {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            correo: true,
          };
        });
        console.log("Correo válido");
      } else {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            correo: false,
          };
        });
        console.log("Correo inválido");
      }
    }

    if (name === "contraseña") {
      if (value.length >= 6) {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            contraseña: true,
          };
        });
        console.log("Contraseña válida");
      } else {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            contraseña: false,
          };
        });
        console.log("Contraseña inválida");
      }
    }

    if (name === "confirmar_contraseña") {
      const contraseña = formDatos.contraseña;
      if (value === contraseña) {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            confirmar_contraseña: true,
          };
        });
        console.log("Confirmación de contraseña válida");
      } else {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            confirmar_contraseña: false,
          };
        });
        console.log("Confirmación de contraseña inválida");
      }
    }

    if (name === "nombre_usuario") {
      if (value.length >= 5) {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            nombre_usuario: true,
          };
        });
        console.log("Contraseña válida");
      } else {
        setValidaciones((prevValidaciones) => {
          return {
            ...prevValidaciones,
            nombre_usuario: false,
          };
        });
        console.log("Contraseña inválida");
      }
    }

    setFormDatos((prevFormDatos) => {
      return {
        ...prevFormDatos,
        [name]: value,
      };
    });
  }

  //verificar condiciones
  useEffect(() => {
    // Verificar si todas las validaciones son true
    const todasLasValidacionesSonTrue = Object.values(validaciones).every(
      (validacion) => validacion === true
    );

    // Actualizar el estado de condicionesValidas
    setCondicionesValidas(todasLasValidacionesSonTrue);
  }, [validaciones]);

  //registrar usuario en base de datos
  async function registro(e) {
    e.preventDefault();
    const { data, error } = await supabase.auth.signUp({
      email: formDatos.correo,
      password: formDatos.contraseña,
      options: {
        data: {
          first_name: formDatos.nombre_usuario,
        },
      },
    });

    if (data) {
      setAlertaRegistro(
        "Te registrarse exitosamente, revisa tu correo para confirmar tu registro"
      );
      setTimeout(() => {
        navigate("/");
      }, 10000);
    }
    if (error) {
      console.log(error);
    }

    setFormDatos({
      correo: "",
      contraseña: "",
      confirmar_contraseña: "",
    });
  }

  return (
    <div className={estilo.registro}>
      <div className={estilo.contenido}>
        <div className={estilo.descripcion}>
          <h2>
            S<em>Person</em>
          </h2>
          <p>Se parte de esta comunidad</p>
        </div>

        <form onSubmit={registro}>
          <div className={estilo.input_datos}>
            <input
              type="text"
              placeholder="Correo"
              name="correo"
              onChange={capturarInputs}
              required
            />
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className={
                validaciones.correo ? estilo.validacion : estilo.no_validacion
              }
            >
              <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
            </svg>
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4z"></path>
            </svg>
          </div>

          <div className={estilo.input_datos}>
            <input
              type="password"
              placeholder="Contraseña"
              name="contraseña"
              onChange={capturarInputs}
              required
            />
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className={
                validaciones.contraseña
                  ? estilo.validacion
                  : estilo.no_validacion
              }
            >
              <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
            </svg>
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M7 17a5.007 5.007 0 0 0 4.898-4H14v2h2v-2h2v3h2v-3h1v-2h-9.102A5.007 5.007 0 0 0 7 7c-2.757 0-5 2.243-5 5s2.243 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z"></path>
            </svg>
          </div>

          <div className={estilo.input_datos}>
            <input
              type="password"
              placeholder="Confirmar contraseña"
              name="confirmar_contraseña"
              onChange={capturarInputs}
              required
            />
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className={
                validaciones.confirmar_contraseña
                  ? estilo.validacion
                  : estilo.no_validacion
              }
            >
              <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
            </svg>
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M7 17a5.007 5.007 0 0 0 4.898-4H14v2h2v-2h2v3h2v-3h1v-2h-9.102A5.007 5.007 0 0 0 7 7c-2.757 0-5 2.243-5 5s2.243 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z"></path>
            </svg>
          </div>

          <div className={estilo.input_datos}>
            <input
              type="text"
              placeholder="Nombre de usuario"
              name="nombre_usuario"
              onChange={capturarInputs}
              required
            />
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className={
                validaciones.nombre_usuario
                  ? estilo.validacion
                  : estilo.no_validacion
              }
            >
              <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
            </svg>
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M12 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm9 11v-1a7 7 0 0 0-7-7h-4a7 7 0 0 0-7 7v1h2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1z"></path>
            </svg>
          </div>

          <button
            type="submit"
            disabled={!condicionesValidas}
            className={
              condicionesValidas
                ? estilo.boton_registrar
                : estilo.no_boton_registrar
            }
          >
            Registrar
          </button>
        </form>

        <div className={estilo.textos}>
          <div className={estilo.alerta}>
            {alertaRegistro && <p>{alertaRegistro}</p>}
          </div>

          <div className={estilo.detalles}>
            <p>
              Ya tienes una cuenta? <Link to={"/ingreso"}>Ingresa</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registro;
